import { ReactNode } from 'react';
import { CsvDownloadButton } from './DownloadButton';

interface ChartContainerProps<T extends Record<string, any>> {
	data: T[] | undefined;
	filename: string;
	children: ReactNode;
	className?: string;
	buttonPosition?: 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}

export function ChartContainer<T extends Record<string, any>>({
	data,
	filename,
	children,
	className = '',
	buttonPosition = 'top-right',
}: ChartContainerProps<T>) {
	const getPositionClass = () => {
		switch (buttonPosition) {
			case 'top-left':
				return 'justify-start';
			case 'top-right':
				return 'justify-end';
			case 'bottom-left':
				return 'justify-start mt-2';
			case 'bottom-right':
				return 'justify-end mt-2';
			default:
				return 'justify-end mb-2';
		}
	};

	const showButtonBefore = buttonPosition === 'top-left' || buttonPosition === 'top-right';

	return (
		<div className={`w-full h-full flex flex-col ${className}`}>
			{showButtonBefore && (
				<div className={`flex ${getPositionClass()}`}>
					<CsvDownloadButton data={data} filename={filename} />
				</div>
			)}

			{children}

			{!showButtonBefore && (
				<div className={`flex ${getPositionClass()}`}>
					<CsvDownloadButton data={data} filename={filename} />
				</div>
			)}
		</div>
	);
}
